import { type RefObject, useCallback, useEffect, useRef } from 'react';
import type {
  ColumnMenuVisibleChangedEvent,
  GridApi,
} from 'ag-grid-enterprise';

type ColumnChooserDismissal = {
  onColumnMenuVisibleChanged: (event: ColumnMenuVisibleChangedEvent) => void;
};

export const useColumnChooserDismissal = (
  gridApiRef: RefObject<GridApi | undefined>
): ColumnChooserDismissal => {
  const isColumnChooserOpenRef = useRef(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isColumnChooserOpenRef.current) {
        gridApiRef.current?.hideColumnChooser();
      }
    };

    const handleMouseDown = (event: MouseEvent) => {
      if (!isColumnChooserOpenRef.current) return;
      const target = event.target as HTMLElement;
      if (!target.closest('.ag-dialog')) {
        gridApiRef.current?.hideColumnChooser();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('mousedown', handleMouseDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleMouseDown);
    };
  }, [gridApiRef]);

  const onColumnMenuVisibleChanged = useCallback(
    (event: ColumnMenuVisibleChangedEvent) => {
      if (event.key === 'columnChooser') {
        isColumnChooserOpenRef.current = event.visible;
      }
    },
    []
  );

  return { onColumnMenuVisibleChanged };
};
